// - In Figma: Prefix all radius variables with 'corner-' and replace underscores with hyphens
//  - In Code: Use camelCase with underscores
//  - Example:
//    - Code: radius_lg -> Figma: corner-radius-lg

const radius = {
  radius_lg: '12px',
  radius_md: '8px',
  radius_sm: '4px',

  // old version
  tiny: '4px',
  small: '8px',
  default: '10px',
  large: '15px',
  button: '12px',
  modal: '16px',
  extraLarge: '20px',
} as const

export default radius
